import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Get tags for a specific marking.
 */
export function getMarkingTags(marking: Markings.Model): string[] {
  const { node, persistent, tags = [], type } = marking;

  return [node ? 'node' : 'board', persistent ? 'persistent' : 'temporary', ...tags, type];
}
